
import { AbstractControl, AsyncValidatorFn, ValidationErrors} from '@angular/forms';
import { Observable,of } from 'rxjs';
import { map } from 'rxjs/operators';
import { RuleService } from '../rule-custom-service';
  
  export class IntelnameValidator {
    static createValidator(ruleservice:RuleService ,rulevarservice:any): AsyncValidatorFn {
      return (control: AbstractControl): Observable<ValidationErrors> => {
        // console.log({intelEditMode})
        if(rulevarservice.intelEditMode){
          return of(null);
        }else{
          return ruleservice.checkIfIntelnameExists(control.value)
          .pipe(
            map((result: any) =>{
              if(result.intellistNameExists){ 
                return {intelnameAlreadyExists: true }
              }else{
                return null
              } 
            })
          );
        }
        
      };
    }
  }